import { LoadingSpinner } from '@/components/LoadingSpinner'
import './searching-component.sass'

function SearchingComponent () {
  return (
    <>
      <div className="searching-messages-container">
        <LoadingSpinner size='small' style={{ display: 'inline' }}/> Searching threads ...
      </div>
    </>
  )
}

export default SearchingComponent
